import { init as initSentry, BrowserOptions } from '@pegasus/sentry';

export type ExtraParams = Record<string, any>;
let instance: ReturnType<typeof initSentry>;

export const init: (initParams: BrowserOptions, extraParams?: ExtraParams) => void = (
    initParams,
    extraParams,
) => {
    instance = initSentry(initParams);

    if (extraParams) {
        instance.setExtras(extraParams);
    }
};

const logInvalidMethodCall = (methodName: string) =>
    // eslint-disable-next-line no-console
    console.log(`[Sentry] Unable to call "${methodName}". Sentry hasn't been initialized.`);

const logParamMissing = (methodName: string, param: string) =>
    // eslint-disable-next-line no-console
    console.log(`[Sentry] ${param} expected while calling the method [${methodName}]`);

export const setExtras = (extraParams: ExtraParams) => {
    if (!instance) {
        logInvalidMethodCall('setExtra');
        return;
    }

    instance.setExtras(extraParams);
};

export const captureException = (error: any) => {
    if (!instance) {
        logInvalidMethodCall('captureException');
        return;
    }

    if (!error) {
        logParamMissing('captureException', 'error');
        return;
    }

    instance.captureException(error);
};
